"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionCollection = void 0;
var tslib_1 = require("tslib");
var api_utils_1 = require("../api-utils/api-utils");
var section_1 = require("../section");
var sub_document_1 = require("../sub-document");
var collection_1 = require("./collection");
var SectionCollection = (function (_super) {
    tslib_1.__extends(SectionCollection, _super);
    function SectionCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionCollection.prototype.find = function (position) {
        api_utils_1.ApiUtils.assertNumber(position, "position");
        var section = this._processor.modelManager.model.getSectionByPosition(position);
        return new section_1.SectionApi(this._processor, section);
    };
    SectionCollection.prototype.create = function (sectionBreakPosition, type) {
        return new sub_document_1.SubDocumentApi(this._processor, this._processor.modelManager.model.mainSubDocument).insertSectionBreak(sectionBreakPosition, type);
    };
    SectionCollection.prototype._getItem = function (coreItem) {
        return new section_1.SectionApi(this._processor, coreItem);
    };
    SectionCollection.prototype._getCoreItems = function () {
        return this._processor.modelManager.model.sections;
    };
    return SectionCollection;
}(collection_1.Collection));
exports.SectionCollection = SectionCollection;
